import { LegacyOrder } from '@hantera/portal-app';
import cleanAssign from "@/clean-assign";
import { reactive } from "vue";

interface Index<T> {
  [id: string]: T
}

export class Cache<T extends Object>  {
  index: Index<T> = {}
  extractId: (entity: T) => string

  constructor(extractId: (entity: T) => string) {
    this.extractId = extractId;
  }

  public get(id: string): T | undefined {
    return this.index[id];
  }

  public addOrUpdate(entity: T) {
    const existing = this.index[this.extractId(entity)];
    if (existing) {
      cleanAssign(existing, entity);
    } else {
      this.index[this.extractId(entity)] = <any>reactive<T>(entity);
    }
  }
}


const legacyOrders = new Cache<LegacyOrder>(o => o.orderId);

export default {
  legacyOrders
};
